export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    ADD_TO_FAVORITE: 'USER_ADD_RESULT_TO_FAVORITE',

    ADD_FAVORITE_REQUEST: 'USERS_ADD_FAVORITE_REQUEST',
    ADD_FAVORITE_SUCCESS: 'USERS_ADD_FAVORITE_SUCCESS',
    ADD_FAVORITE_FAILURE: 'USERS_ADD_FAVORITE_FAILURE',

    QUERY_LIBRARY_REQUEST: 'USERS_QUERY_LIBRARY_REQUEST',
    QUERY_LIBRARY_SUCCESS: 'USERS_QUERY_LIBRARY_SUCCESS',
    QUERY_LIBRARY_FAILURE: 'USERS_QUERY_LIBRARY_FAILURE',
    UPDATE_LIBRARY_UPDATE: 'USERS_UPDATE_LIBRARY',
};



// WEBPACK FOOTER //
// ./src/_constants/user.constants.js